/* ============================================
   SCREEN 7.5: PROCESSING INTERSTITIAL
   quiz-processing.js — loaded by longevity-quiz-2026
   ============================================
   Plays a 3.3s staged "analysis" animation between Q6 and email capture.
   Each line fades in sequentially, gets a checkmark when done.
   A thin progress bar fills across the full duration.
   After completion, fades out and hands off to showEmailCapture().
   
   Dependencies (all global from main quiz script):
   - t()               : translation helper
   - showEmailCapture() : email gate screen
   - DOM: #navigation, #progressFill, #progressText, #quizContent
   ============================================ */

function showProcessingScreen() {
    document.getElementById('navigation').classList.add('hidden');
    document.getElementById('progressFill').style.width = '88%';
    document.getElementById('progressText').textContent = '';

    var checkSvg = '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">'
        + '<path d="M2.5 6L5 8.5L9.5 3.5" stroke="#4ade80" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
        + '</svg>';
    var dots = '<span class="processing-dots"><span></span><span></span><span></span></span>';

    var lines = [t('processing.line1'), t('processing.line2'), t('processing.line3')];
    var linesHtml = '';
    for (var i = 0; i < lines.length; i++) {
        linesHtml += '<div class="processing-line" id="procLine' + i + '">'
            + '<div class="processing-check">' + checkSvg + '</div>'
            + '<span class="processing-text">' + lines[i]
            + '<span class="processing-dots" id="procDots' + i + '"><span></span><span></span><span></span></span>'
            + '</span></div>';
    }

    document.getElementById('quizContent').innerHTML =
        '<div class="processing-screen" id="processingScreen">'
        + '<div class="processing-lines">' + linesHtml + '</div>'
        + '<div class="processing-progress">'
        + '<div class="processing-progress-fill" id="procProgressFill"></div>'
        + '</div></div>';

    var TOTAL = 3300;
    var stages = [
        { start: 0,    end: 1200 },
        { start: 1200, end: 2500 },
        { start: 2500, end: 3100 }
    ];

    var bar = document.getElementById('procProgressFill');
    var t0 = performance.now();
    function tick() {
        var pct = Math.min((performance.now() - t0) / TOTAL * 100, 100);
        if (bar) bar.style.width = pct + '%';
        if (pct < 100) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    stages.forEach(function(s, idx) {
        setTimeout(function() {
            var el = document.getElementById('procLine' + idx);
            if (el) el.classList.add('visible');
        }, s.start);

        setTimeout(function() {
            var el = document.getElementById('procLine' + idx);
            var dd = document.getElementById('procDots' + idx);
            if (el) el.classList.add('completed');
            if (dd) dd.style.display = 'none';
        }, s.end);
    });

    setTimeout(function() {
        var screen = document.getElementById('processingScreen');
        if (screen) screen.classList.add('fade-out');
        setTimeout(function() { showEmailCapture(); }, 250);
    }, TOTAL);
}